var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isPremium)?_c('div',{staticClass:"horizontal-banner"},[_c('a',{attrs:{"href":"https://proxpect.com.br/transportadora.html#premium","target":"_blank"}},[_c('v-img',{attrs:{"src":require("../assets/banner-h.svg")}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }